interface Options {
  transactionId: string;
  summary: string;
  description: string;
}

export const useRewardAgent = () => {
  const getReward = async (user: User): Promise<Reward> => {
    const result = {
      rewardPoints: 0,
      multiplier: 0,
      cashValue: 0,
      rawData: null,
    }
    const response: any = await $rewardServer('/reward/fetch', {
      method: 'post',
      body: {
        provider_id: useRuntimeConfig().public.reward.provider.toUpperCase(),
        mobile: user.phone?.toString(),
      },
    });
    console.log(response.data)
    const { rewardpoints, multiplier, cashvalue, rawdata } = response?.data || {};
    result.rewardPoints = Number(rewardpoints || 0);
    result.multiplier = Number(multiplier || 0);
    result.cashValue = Number(cashvalue || 0);
    result.rawData = rawdata || null;
    return result;
  };

  const redeemPoints = async (user: User, points: number, { transactionId, summary, description }: Options): Promise<void> => {
    const dayjs = useDayjs();

    await $rewardServer('/reward/redeem', {
      method: 'post',
      body: {
        provider_id: useRuntimeConfig().public.reward.provider.toUpperCase(),
        mobile: user.phone?.toString(),
        points: Number(points),
        item: summary,
        item_description: description,
        transaction_id: transactionId,
      },
    });
  };

  return { getReward, redeemPoints };
};
